import { createContext, useState, useEffect } from "react";
import axios from "axios";
import { readBackendToken, storeBackendToken, rememberDastDestination, restoreDastDestination } from "../scripts/authSession";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const apiUrl = import.meta.env.VITE_API_URL;
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(readBackendToken);
  const [entrepriseRoles, setEntrepriseRoles] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchUser = async (currentToken = token) => {
    try {
      const res = await axios.get(
        `${apiUrl}api/me`,
        { withCredentials: true, headers: currentToken ? { Authorization: `Bearer ${currentToken}` } : {} }
      );
      await fetchRoles(currentToken);
      restoreDastDestination();
      setUser(res.data);
      return true;
    } catch (error) {
      setUser(null);
      setEntrepriseRoles([]);
      setToken(null);
      storeBackendToken(null);
      return false;
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Fonction pour récupérer les rôles
  const fetchRoles = async (currentToken = token) => {
    try {
      const res = await axios.get(`${apiUrl}menu`, { withCredentials: true, headers: currentToken ? { Authorization: `Bearer ${currentToken}` } : {} });
      setEntrepriseRoles(res.data[0].roles);
    } catch (error) {
      setEntrepriseRoles([]);
    }
  };

  const login = async (backendToken) => {
    const nextToken = typeof backendToken === "string" ? backendToken : null;
    setToken(nextToken);
    storeBackendToken(nextToken);
    if (!await fetchUser(nextToken)) throw new Error("Authentication failed");
  };

  const reauthenticate = () => {
    rememberDastDestination();
    storeBackendToken(null);
    setToken(null);
    setUser(null);
    setEntrepriseRoles([]);
  };


  const logout = async () => {
    try {
      await axios.post(`${apiUrl}api/logout`, {}, { withCredentials: true });
      setUser(null);
      setToken(null);
      storeBackendToken(null);
      window.location = "/";
    } catch (error) {
      console.error("Erreur lors de la déconnexion :", error);
    }
  };

  useEffect(() => {
    rememberDastDestination();
    fetchUser();
  }, []);

  return (
    <AuthContext.Provider value={{ user, token, reauthenticate, entrepriseRoles, login, logout, isLoading, apiUrl, fetchRoles, fetchUser }}>
      {children}
    </AuthContext.Provider>
  );
}
